import React from 'react'
import web from "../images/web.svg"
import front from "../images/front.svg";
import database from "../images/backend.svg";
import backend from "../images/database.svg";
import git from "../images/github.svg"
import figma from "../images/figma.svg"
import python from "../images/python.svg";



export const Skills = () => {
    return (
     
        <section className="bg-white py-20 ">
            <div className="max-w-5xl px-6 mx-auto text-center h-screen">
                <h2 className="text-center mx-auto underline sm:text-4xl text-3xl font-bold title-font mb-5 ">Skills</h2>

                <div className="flex flex-col items-center justify-center mt-5 h-screen">
                    <div className="max-w-2xl w-full block bg-white shadow-md rounded-md border-t-4 border-indigo-600 transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110" >
                        <div className="flex items-center justify-between px-4 py-2">
                        <img src={web} alt="web" className="xl:block hidden" />
                            <h3 className="text-lg font-medium text-gray-700">Web design and development</h3>
                            <span className="block text-gray-600 font-light text-sm">(HTML/CSS/Javascript)</span>
                        </div>
                    </div>

                    <div className="mt-8 max-w-2xl w-full block bg-white shadow-md rounded-md border-t-4 border-indigo-600 transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110" >
                        <div className="flex items-center justify-between px-4 py-2">
                        <img src={python} alt="web" className="xl:block hidden" />
                            <h3 className="text-lg font-medium text-gray-700">Python Scripting</h3>
                            <span className="block text-gray-600 font-light text-sm">(Python 3)</span>
                        </div>
                    </div>

                    <div className="mt-8 max-w-2xl w-full block bg-white shadow-md rounded-md border-t-4 border-indigo-600 transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110" >
                        <div className="flex items-center justify-between px-4 py-2">
                        <img src={database} alt="web" className="xl:block hidden" />
                            <h3 className="text-lg font-medium text-gray-700">Database Management System</h3>
                            <span className="block text-gray-600 font-light text-sm">(Postgresql/Sqlite)</span>
                        </div>
                    </div>

                    <div className="mt-8 max-w-2xl w-full block bg-white shadow-md rounded-md border-t-4 border-indigo-600 transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110" >
                        <div className="flex items-center justify-between px-4 py-2">
                        <img src={front} alt="web" className="xl:block hidden" />
                            <h3 className="text-lg font-medium text-gray-700">Frontend Frameworks</h3>
                            <span className="block text-gray-600 font-light text-sm">(React.js/ Angular)</span>
                        </div>
                    </div>
                    <div className="mt-8 max-w-2xl w-full block bg-white shadow-md rounded-md border-t-4 border-indigo-600 transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110" >
                        <div className="flex items-center justify-between px-4 py-2">
                        <img src={backend} alt="web" className="xl:block hidden" />
                            <h3 className="text-lg font-medium text-gray-700">Backend Frameworks</h3>
                            <span className="block text-gray-600 font-light text-sm">(Django)</span>
                        </div>
                    </div>
                    <div className="mt-8 max-w-2xl w-full block bg-white shadow-md rounded-md border-t-4 border-indigo-600 transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110" >
                        <div className="flex items-center justify-between px-4 py-2">
                        <img src={figma} alt="web" className="xl:block hidden" />
                            <h3 className="text-lg font-medium text-gray-700">UI/UX Design</h3>
                            <span className="block text-gray-600 font-light text-sm">(Figma)</span>
                        </div>
                    </div>
                    <div className="mt-8 max-w-2xl w-full block bg-white shadow-md rounded-md border-t-4 border-indigo-600 transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110" >
                        <div className="flex items-center justify-between px-4 py-2">
                        <img src={git} alt="web" className="xl:block hidden" />
                            <h3 className="text-lg font-medium text-gray-700">Others</h3>
                            <span className="block text-gray-600 font-light text-sm">(Git)</span>
                        </div>
                    </div>
                </div>

               
            </div>
        </section>
    )
}
